import { LocalStoreHandler } from '../../helpers/local-storage-handler';

type UserProperties = Record<string, string>;

export class UserHandler {
  public static readonly STORAGE_KEY = 'userProperties';

  /** Add or replace a user property (string only) */
  public addProperty(key: string, value: string): void {
    const props = this.getAllProperties();
    props[key] = value;
    this.persist(props);
  }

  /** Get a user property value; returns undefined if not set */
  public getProperty(key: string): string | undefined {
    const props = this.getAllProperties();
    return props[key];
  }

  /** Remove a user property */
  public removeProperty(key: string): void {
    const props = this.getAllProperties();
    if (key in props) {
      delete props[key];
      this.persist(props);
    }
  }

  /** Get all user properties as a single object */
  public getAllProperties(): UserProperties {
    const data: any = LocalStoreHandler.get() ?? {};
    const props = (data?.[UserHandler.STORAGE_KEY] ?? {}) as UserProperties;
    // Ensure we always return a plain object
    return { ...props };
  }

  /**
   * Merge provided customAttributes.attributes with user properties.
   * customAttributesAttributes always override user properties on key conflicts.
   */
  public mergeWithCustomAttributes(
    customAttributesAttributes?: Record<string, string>
  ): UserProperties {
    const userProps = this.getAllProperties();
    return {
      ...userProps,
      ...(customAttributesAttributes ?? {}),
    };
  }

  /** Persist the provided properties under the dedicated storage key */
  private persist(props: UserProperties): void {
    LocalStoreHandler.update({
      [UserHandler.STORAGE_KEY]: props,
    });
  }
}
